/** Read PNG width/height from IHDR without full decode. */
export function getPngSize(pngBytes: Uint8Array): { width: number; height: number } | null {
  // PNG signature (8) + IHDR length(4) + type(4) + width(4) + height(4)
  if (pngBytes.length < 24) return null;
  const isPng =
    pngBytes[0] === 0x89 &&
    pngBytes[1] === 0x50 &&
    pngBytes[2] === 0x4e &&
    pngBytes[3] === 0x47;
  if (!isPng) return null;
  const view = new DataView(pngBytes.buffer, pngBytes.byteOffset, pngBytes.byteLength);
  const width = view.getUint32(16);
  const height = view.getUint32(20);
  if (width < 1 || height < 1) return null;
  return { width, height };
}

export function pngAspectRatio(pngBytes: Uint8Array, fallback = 2.5): number {
  const size = getPngSize(pngBytes);
  if (!size) return fallback;
  return size.width / size.height;
}
